/**
 * Class Utils
 * Contains useful methods for visibility in general
 */
export default class Utils {

	static dataSelector = 'data-visibility'; // Holds all visibility data from elementor controls
	static hideClass = 'elementor-network-hidden'; // CSS class that hides the elements on the DOM
	static allHideSelector = 'visibility-all-hide'; // True || False whether all the element conditions are hide conditions

	/**
	 * compareRequestToSettings
	 * @param element
	 * @param settings
	 * @param request
	 * @param elementIsAllHide
	 * @returns {*[]}
	 */
	static compareRequestToSettings( element, settings, request, elementIsAllHide, showAllHideElement ) {

		let matchingShowEntries = [];
		for ( const requestEntry of request ) {
			for ( const settingsEntry of settings ) {
				if ( Utils.entriesAreEqual( settingsEntry, requestEntry ) ) {
					matchingShowEntries = Utils.checkShowHide( settingsEntry, element, elementIsAllHide, showAllHideElement );
				}
			}
		}

		return matchingShowEntries;

	}

	static checkShowHide( entry, element, elementIsAllHide, showAllHideElement ) {
		let showEntries = [];
		if ( 'show' === entry.type ) {
			showEntries.push( entry );
			element.classList.remove( Utils.hideClass );
		}
		if ( 'hide' === entry.type && elementIsAllHide ) {
			showAllHideElement.show = false;
		}
		return showEntries;
	}

	/**
	 * entriesAreEqual
	 * @param firstEntry
	 * @param secondEntry
	 * @returns {boolean}
	 */
	static entriesAreEqual( firstEntry, secondEntry ) {
		return firstEntry.name === secondEntry.name && firstEntry.value === secondEntry.value;
	}

	/**
	 * Helper function to get the value of a specific cookie by name.
	 * @param name
	 * @returns {*}
	 */
	static getCookie( name ) {

		const key = name + "=";
		const cookie_decoded = decodeURIComponent( document.cookie );
		const cookie_array = cookie_decoded.split( '; ' );
		let result;
		cookie_array.forEach( value => {
			if ( value.indexOf( key ) === 0) {
				result = value.substring( key.length );
			}
		})
		return result

	}

	/**
	 * Create a new cookie for the site.
	 * @param name The key of the cookie
	 * @param value The value of the cookie
	 * @param seconds Number of seconds from creation the cookie will be active for
	 */
	static setCookie( name, value, seconds ) {

		let expires = '';
		let date = new Date();
		date.setTime( date.getTime() + ( seconds * 1000 ) );
		expires = '; expires=' + date.toGMTString();
		document.cookie = name + '=' + value + expires + '; path=/';

	}

	/**
	 * get visibility data
	 *
	 * @param element
	 * @returns {any}
	 */
	static getData( element ) {
		return JSON.parse( element.getAttribute( Utils.dataSelector ) );
	}

	/**
	 * get all-hide data
	 *
	 * @param element
	 * @returns {string}
	 */
	static isAllHide( element ) {
		return element.getAttribute( Utils.allHideSelector );
	}

}
